export enum ChatMessageSource {
  USER = 'user',
  BOT = 'bot',
  SYSTEM = 'system',
}
